import { SceneBase } from '@jollywise/jollygoodgame';
import { KEYS } from 'game/constants/SceneConstants';
import { ButtonSimple } from '@jollywise/jollygoodgame';
import { DisplayDocumentEmail } from 'game/display/DisplayDocumentEmail';
import { DisplayDocumentDossier } from 'game/display/DisplayDocumentDossier';
import { DisplayDocumentQuote } from 'game/display/DisplayDocumentQuote';

export class ModalDocument extends SceneBase {
  constructor() {
    super({ key: KEYS.ModalDocument, active: false });
  }

  init(config) {
    this._id = config.data.doc_id + 1;
    this._data = { ...config.data };
    this._currentType = this._data?.data?.type || '';
  }

  create() {
    this.game.hud.setState('EMPTY');

    this.createOverlayBg();

    this.docContainer = this.add.container(0, this.game.defaultHeight);

    this.documentBackground = this.add
      .sprite(840, this.game.defaultHeight, 'backgrounds', 'background_document')
      .setOrigin(0.5, 1);

    this.textContainer = this.displayDocumentData();

    this.textContainer.x = this.documentBackground.x - this.documentBackground.width / 2;
    this.textContainer.y = this.documentBackground.y - this.documentBackground.height;

    this.aideAvatar = this.add
      .sprite(
        840 + this.documentBackground.width / 2,
        this.game.defaultHeight,
        'ui',
        `document_aide_${this._id}`
      )
      .setOrigin(0);

    this.aideAvatar.y -= this.aideAvatar.height;

    this.aideAvatar.x -= this.aideAvatar.width - 20;

    this.docContainer.add([this.documentBackground, this.textContainer, this.aideAvatar]);

    this.add.tween({
      targets: this.docContainer,
      y: 0,
      duration: 500,
      ease: Phaser.Math.Easing.Back.In,
      onComplete: () => {
        this.game.soundController.playSFX('sfx', 'chn_document_open');

        this.displayContinueButton();
      },
    });
  }

  createOverlayBg() {
    this.overlayBg = this.add
      .rectangle(0, 0, this.game.defaultWidth, this.game.defaultHeight, 0x000000)
      .setOrigin(0);
    this.overlayBg.alpha = 0.8;
  }

  displayDocumentData() {
    const { data = {} } = this._data;

    switch (this._currentType) {
      case 'email':
        return new DisplayDocumentEmail(this, data);
      case 'dossier':
        return new DisplayDocumentDossier(this, data);
      case 'quote':
        return new DisplayDocumentQuote(this, data);
      default:
        return this.add.container(0, 250);
    }
  }

  displayContinueButton() {
    this.continue = new ButtonSimple(this, {
      x: 840,
      y: this.game.defaultHeight - 40,
      id: 'btn_continue',
      costume: 'btn_continue',
      clickSFX: { sprite: 'sfx', id: 'chn_button_click' },
    }).setOrigin(0.5, 1);

    this.continue.alpha = 0;

    this.docContainer.add(this.continue);

    this.add.tween({
      targets: this.continue,
      alpha: 1,
      duration: 500,
      ease: Phaser.Math.Easing.Back.In,
      onComplete: () => {
        this.continue.on('pointerdown', () => {
          this.closeOverlay();
        });
      },
    });
  }

  closeOverlay() {
    this.add.tween({
      targets: this.docContainer,
      y: this.game.defaultHeight,
      duration: 500,
      ease: Phaser.Math.Easing.Back.Out,
      onComplete: () => {
        this.game.hud.setState('GAME');
        this.shutdown();
      },
    });
  }

  shutdown() {
    // emit event to continue game
    this.game.events.emit('document:close');

    this.continue.off('pointerdown', () => {
      this.closeOverlay();
    });
    this.game.sceneController.removeOverlayScene();
  }
}
